"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHOW_SCROLL_CLASS = exports.SCROLLER_CLASS = exports.SCROLLER_SCROLLABLE_CONTENT_CLASS = exports.SCROLLER_SCROLLABLE_CLASS = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.SCROLLER_SCROLLABLE_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-scrollable");
exports.SCROLLER_SCROLLABLE_CONTENT_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-content-wrapper");
exports.SCROLLER_CLASS = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-content-scroller");
exports.SHOW_SCROLL_CLASS = 'showScroll';
